import React from 'react';
import { connect } from 'react-redux';
import { withRouter, Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { BaseListContainer } from 'containers/BaseContainer/BaseListContainer';
import { setMenuSelected, setMenuSelected_2 } from '@redux/actions/menuAction';
import moment from 'moment';
import { DATE_FORMAT } from 'config';
import { getList, exportData } from 'api/facilitypermitApi';
import slug from 'constants/slug';
import styled from 'styled-components';
import { Row, Col } from 'reactstrap';
import YearSelect from 'components/elements/select-year';
import PermitTypeSelect from 'components/elements/select-permit-type';
// import FacilitySelect from 'components/elements/select-facility';
import _ from 'lodash';
import Clearfix from 'components/elements/clearfix';
import { createForm } from 'rc-form';
import PageLockHOC from 'hoc/pageLock';
import { COLOR } from 'config';
import { IS_ENTERPRISE } from 'config';

const NameContainer = styled.div`
  color: ${COLOR.SECOND_COLOR};
  text-decoration: underline;
`;
@PageLockHOC(['facilityPermit.view'])
class FacilitypermitList extends BaseListContainer {
  static propTypes = {
    facilityId: PropTypes.string,
    hideRightHeaderContent: PropTypes.bool,
  };

  constructor(props) {
    const funcApi = {
      getList,
      exportData,
    };
    const columns = [
      {
        dataField: 'facility.FacilityNameFull',
        text: 'Tên cơ sở/dự án',
        formatter: (cell, row) => {
          return (
            <Link
              target='_blank'
              to={slug.FACILITY_PERMIT.VIEW_WITH_ID + row._id}
              onClick={() => {
                this.props.setMenuSelected_2(null);
              }}
            >
              <NameContainer>{cell}</NameContainer>
            </Link>
          );
        },
      },
      ...(!IS_ENTERPRISE && [
        {
          dataField: 'facility.organizationName',
          text: 'Tên doanh nghiệp',
          formatter: (cell, row) => {
            return <div style={{ width: 200 }}>{cell ? cell : ''}</div>;
          },
        },
      ]),
      {
        dataField: 'LicenseNumber',
        text: 'Số giấy phép',
        formatter: (cell, row) => {
          return <div>{cell ? cell.value : ''}</div>;
        },
      },
      {
        dataField: 'permitType',
        text: 'Loại giấy phép',
        formatter: (cell, row) => {
          return <div>{cell ? cell.Name : ''}</div>;
        },
      },
      {
        dataField: 'LicenseName',
        text: 'Tên giấy phép',
        formatter: (cell, row) => {
          return <div>{cell ? cell : ''}</div>;
        },
      },
      {
        dataField: 'IssueDate',
        text: 'Ngày cấp',
        formatter: (cell, row) => {
          return <div>{cell ? moment(cell).format(DATE_FORMAT) : ''}</div>;
        },
      },
      {
        dataField: 'ExpiryDate',
        text: 'Ngày hết hạn',
        formatter: (cell, row) => {
          return <div>{cell ? moment(cell).format(DATE_FORMAT) : ''}</div>;
        },
      },
    ];

    super(
      props,
      funcApi,
      columns,
      `${slug.FACILITY_PERMIT.CREATE}?facilityId=${props.facilityId}`,
      'facilityPermit',
      null,
      true,
      true
    );

    this.state = {
      ...this.state,
      valueSearch: {
        facility: this.props.facilityId,
      },
    };
  }

  // renderSearchContainer() {
  //   return (
  //     <div>
  //       {super.renderSearchContainer()}
  //       {this.renderSearchExpandContainer()}
  //     </div>
  //   );
  // }

  renderSearchExpandContainer = () => {
    const form = this.props.form;
    return (
      <div>
        <Clearfix height={8} />
        <Row>
          <Col xs={4}>
            <YearSelect
              label={'Năm cấp'}
              fieldForm={{
                form: form,
                name: 'year',
              }}
            />
          </Col>
          <Col xs={4}>
            <PermitTypeSelect
              label={'Loại giấy phép'}
              fieldForm={{
                form: form,
                name: 'permitType',
              }}
            />
          </Col>
        </Row>
      </div>
    );
  };

  handelSubmitSearch(values) {
    values.permitType = _.get(values.permitType, 'value');
    values.year = _.get(values.year, 'value');

    super.handelSubmitSearch(values);
  }
}

const mapStateToProps = (state) => ({
  menuStore: state.menu,
});

const mapDispatchToProps = {
  setMenuSelected,
  setMenuSelected_2,
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(createForm()(FacilitypermitList))
);



// WEBPACK FOOTER //
// ./src/containers/FacilitypermitContainer/FacilitypermitList/index.js